<template>
  <div class="schedule-page">
    <schedule-page-header />
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card class="md-card-calendar" style="box-shadow: none">
          <events-search-bar ref="searchBar" />
          <div
            :class="
              shouldShowEventAdditionBar ? 'justify-between' : 'justify-end'
            "
            class="flex items-center"
          >
            <event-addition-bar v-if="shouldShowEventAdditionBar" />
            <div class="mr-8">
              <MonthPicker
                ref="datePicker"
                v-model="datePicker"
                type="month"
                @change="changeValue($event)"
              ></MonthPicker>
            </div>
          </div>

          <div class="relative">
            <grid-calendar
              v-if="showCalender"
              ref="gridCalendarRef"
              :initialDate="datePicker"
              class="grid-calendar absolute w-full bg-white"
            />
            <div class="event-glossary absolute">
              <event-glossary></event-glossary>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import SchedulePageHeader from "./Header";
import GridCalendar from "./GridCalendar";

import EventsSearchBar from "./SearchBar";
import EventAdditionBar from "./Event/AdditionBar";
import EventGlossary from "./Glossary.vue";

import { service_paths } from "@/constants/Services";
import { convertSISEvent2CalendarEvent } from "./Event/event-utils";
import { getDate, getTimeString } from "@/helpers/datetime-helper";
import { getId } from "@/helpers/utils";

import Role from "@/constants/Role";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import { Calendar } from "@/constants/Permissions";

import MonthPicker from "@/components/Base/Vue2DatePicker/MonthPicker";
import moment from "moment";

export default {
  components: {
    SchedulePageHeader,
    EventsSearchBar,
    GridCalendar,
    EventAdditionBar,
    EventGlossary,
    MonthPicker
  },
  data() {
    return {
      datePicker: "",
      showCalender: true,
      events: []
    };
  },
  created() {
    let month = this.$route.query.month;
    if (month) {
      this.$router.replace({ query: {} });
      this.datePicker = month;
    } else {
      this.datePicker = moment().format("YYYY-MM");
    }
  },
  computed: {
    shouldShowEventAdditionBar() {
      return this.$can(Calendar.actions.add, Calendar.subject);
    },
    ...mapGetters("user", {
      userRole: "role"
    }),
    activatedRole() {
      return this.userRole[0];
    },
    hasDefaultView() {
      return hasValidRole(this.userRole, [Role.Admin, Role.Principal]);
    }
  },
  methods: {
    changeValue() {
      this.showCalender = false;
      setTimeout(() => {
        this.showCalender = true;
      }, 1);
    },
    getEvents(info, successCallback, _failureCallback) {
      const { startStr, endStr, start, end, timezone } = info;
      const startDate = getDate(startStr);
      const endDate = getDate(endStr);
      const queryParams = this.genQueryParams();
      const apiPath = this.getCalendarApiPath();
      const self = this;
      if (this.hasDefaultView) {
        function mapListEvents(data) {
          const filteredDates = [
            ...data
              .flat()
              .reduce((map, obj) => map.set(getId(obj), obj), new Map())
              .values()
          ];
          const events = filteredDates.map(sisEvent =>
            convertSISEvent2CalendarEvent(self.userRole, sisEvent)
          );
          successCallback(events);
        }

        async function fetchListEvents(startDate, endDate) {
          let { data } = await self.$axios.get(apiPath, {
            ...queryParams,
            start: startDate,
            end: endDate
          });
          return data;
        }

        const midDate = new Date((start.getTime() + end.getTime()) / 2);
        let nextOfMidDate = new Date(midDate);
        nextOfMidDate.setDate(nextOfMidDate.getDate() + 1);
        let midDateStr = getTimeString(nextOfMidDate, timezone, "YYYY-MM-DD");
        let nextOfMidDateStr = getTimeString(midDate, timezone, "YYYY-MM-DD");
        Promise.all([
          fetchListEvents(startDate, midDateStr),
          fetchListEvents(nextOfMidDateStr, endDate)
        ]).then(data => {
          mapListEvents(data);
        });
        return;
      }
      this.$axios
        .get(apiPath, {
          ...queryParams,
          start: startDate,
          end: endDate
        })
        .then(({ data: sisEvents }) => {
          const events = sisEvents.map(sisEvent =>
            convertSISEvent2CalendarEvent(this.userRole, sisEvent)
          );
          successCallback(events);
        });
    },

    refetchEvents() {
      const calendarApi = this.$refs.gridCalendarRef.getCalendarApi();

      if (calendarApi) {
        calendarApi.refetchEvents();
        return;
      }

      console.log("Not exist calendar api.");
    },

    getCalendarApiPath() {
      if (this.hasDefaultView) {
        return service_paths.calendars;
      }

      return `${service_paths.calendars}/current-user`;
    },

    genQueryParams() {
      return {
        role_active: this.activatedRole,
        ...this.$refs.searchBar.getQueryParams()
      };
    }
  },
  provide() {
    return {
      getEvents: this.getEvents,
      refetchEvents: this.refetchEvents
    };
  }
};
</script>
<style lang="scss">
.grid-calendar {
  top: -10px;
  border-radius: 0 0 6px 6px;
  padding: 15px;
}

.event-glossary {
  top: 1150px;
  right: 0;
}

.grid-calendar .fc .fc-popover {
  z-index: 10 !important;
}
</style>
